import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ContractSettingsModel} from '../../../../models/ContractSettingsModel';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {ProviderFilterComponent} from '../../../general-components/filter/provider-filter/provider-filter.component';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import { Offset } from 'src/models/Offset';
import {forkJoin, Observable} from 'rxjs';
import {ContractTypeSettingsService} from '../service/contract-type-settings.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';

@Component({
  selector: 'app-filter-contract',
  templateUrl: './filter-contract.component.html',
  styleUrls: ['./filter-contract.component.scss']
})
export class FilterContractComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() providerData?: any;
  @Input() filter?: ContractSettingsModel;

  regionData: any;
  contractTypeData: any;

  @Output() dataFiltered = new EventEmitter<any>();
  @Output() resetDataFiltered = new EventEmitter<any>();

  @ViewChild(ProviderFilterComponent) providerFilterComponent;
  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeComponent;

  filterSingle: ContractSettingsModel;
  offset: Offset;
  dataSource: any;
  intermittentBool: boolean;


  constructor(private contractTypeSettingsService: ContractTypeSettingsService,
              private loaderService: LoaderService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private contractTypeService: ContractTypeService) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ContractSettingsModel();
    }
    this.filterSingle = ContractSettingsModel.clone(this.filter);
    this.offset = new Offset(10, 0);
    if (JSON.parse(sessionStorage.getItem('contractSettingFilter'))) {
      this.filter = JSON.parse(sessionStorage.getItem('contractSettingFilter'));
    }
    if (this.showNewEditDelete === undefined) {
      this.showNewEditDelete = true;
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allContractTypeSettingFilterModel: ContractSettingsModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInContractTypeSetting(this.filterSingle).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInContractTypeSetting(this.filterSingle).pipe();


    forkJoin([getAllRegionObservable, getAllContractTypeObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptProviderChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.provider = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInContractTypeSetting(this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInContractTypeSetting(this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];


          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInContractTypeSetting(this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInContractTypeSetting(this.filterSingle).pipe();


    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.contractTypeData = resultFork[1];

          this.filter.provider = this.filterSingle.provider;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    this.intermittentBool = true;
    this.intermittentFilterButton(this.intermittentBool);

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    const getAllProviderFilteredObservable: Observable<any> = this.providerService.getListInContractTypeSetting(this.filterSingle).pipe();
    const getAllRegionObservable: Observable<any> = this.regionService.getListInContractTypeSetting(this.filterSingle).pipe();


    observableList.push(getAllProviderFilteredObservable);
    observableList.push(getAllRegionObservable);


    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.providerData = resultFork[0];
          this.regionData = resultFork[1];

          this.filter.provider = this.filterSingle.provider;
          this.filter.region = this.filterSingle.region;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }


  filterTable(): void {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    this.getAllFilters();

    sessionStorage.setItem('contractSettingFilter', JSON.stringify(this.filter));


    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    this.intermittentBool = false;
    this.intermittentFilterButton(this.intermittentBool);

    const isReset = true;
    this.filter = new ContractSettingsModel();
    this.filterSingle = new ContractSettingsModel();

    const getFirstProviderObservable: Observable<any> = this.providerService.getListInContractTypeSetting(this.filterSingle).pipe();

    getFirstProviderObservable
      .subscribe(
        (result: any) => {
          this.providerData = result;

          this.filter.provider = result ? result[0] : null;

          sessionStorage.setItem('contractSettingFilter', JSON.stringify(this.filter));
          this.filterSingle = new ContractSettingsModel();
          if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONTRACT_SETTING_FILTER))) {
            this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.CONTRACT_SETTING_FILTER));
          }
          this.initFilter(this.filterSingle, isReset);
        }, error => {
          console.log(error);
        });
  }

  getAllFilters() {
    this.filter.provider = this.providerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeComponent.optionSelected;
  }

  ngOnDestroy(): void {
  }

}
